module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header_top"
  }, [_c('a', {
    staticClass: "head_goback",
    on: {
      "click": _vm.back
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/true.png")
    }
  })]), _vm._v(" "), _c('h5', {
    staticClass: "tlt"
  }, [_vm._v("\n\t \t" + _vm._s(_vm.title) + "\n\t")]), _vm._v(" "), _vm._t("edit")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66d528ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/header/head.vue
// module id = 161
// module chunks = 18